{
  "el": {
    "Yes": "Ναι",
    "dxDataGrid-summaryCount": "Σύνολο: {0}"
  }
}
